import React, { useState } from "react";
import { Form } from "react-bootstrap";
import cross from "../assets/images/cross1.svg";

/**
 * ChipsInput
 *
 * Free text field that turns whatever is typed into a removable chip.
 * Enter, Tab or comma commits the current text, the cross on a chip removes it.
 *
 * @param {string[]} value - Committed chips.
 * @param {function} onChange - Called with the next chips array on add/remove.
 * @param {string} placeholder - Input placeholder.
 * @param {boolean} allowDuplicates - Keep repeated entries instead of ignoring them.
 * @param {string} className - Class names applied to the input.
 * @param {object} style - Inline styles merged into the input.
 */
const ChipsInput = ({
  value = [],
  onChange = () => {},
  placeholder = "Press Enter To Add",
  allowDuplicates = false,
  className = "bottomBorderField custom-placeholder",
  style = {},
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === "Tab" || e.key === ",") && searchTerm.trim() !== "") {
      e.preventDefault();

      const chip = searchTerm.trim();

      if (allowDuplicates || !value.includes(chip)) {
        onChange([...value, chip]);
      }

      setSearchTerm("");
    }
  };

  const handleRemove = (index) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <>
      {value?.length ? (
        <div className="css-hq12ga">
          <div
            className="d-flex flex-row flex-wrap align-items-center"
            style={{ marginLeft: "6px" }}
          >
            {value.map((i, index) => (
              <div key={index} className="maidBAr">
                <div className="manBarText" style={{ fontSize: "9.35px" }}>
                  {i}
                </div>
                <div className="mainBarIcon" onClick={() => handleRemove(index)}>
                  <img src={cross} alt="Remove" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <Form.Control
        type="text"
        placeholder={placeholder}
        className={className}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ minHeight: "30px", ...style }}
        onKeyDown={handleKeyDown}
      />
    </>
  );
};

export default ChipsInput;
